import { ErrorDetailComponent } from './ErrorDetail';
import { connect } from 'react-redux';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state: any) => ({});
const mapDispatchToProps = {};

export const ErrorDetail = connect(mapStateToProps, mapDispatchToProps)(ErrorDetailComponent);
